export default __webpack_public_path__ + "4513b2ac13787fc2f81ef9bfaddd5a44.otf";